import { AppRoute } from "modules/routing/types/AppRoute";
import { NewOpportunity } from "../pages/NewOpportunity/NewOpportunity";

export const opportunityReportNew = '/opportunity/new';

export const opportunityReportNewRoutes: AppRoute[] = [
    {
        name: 'New-Opportunity',
        path: opportunityReportNew,
        exact: true,
        component: NewOpportunity
    }
];